import React, {Fragment} from "react";
import {Divider, Grid} from "@mui/material";
import {useStyles} from './styles'

function TituloConImagen(props) {
  const classes = useStyles(props);
  return (
    <Fragment>
      <Grid container justifyContent={"center"} alignItems="center" flexDirection="column">
        {props.showIcon && (
          <img className={classes.icon} src={`/menu/${props.icon ? props.icon : "Formulario"}.png`} alt="Icon Formulario"/>
        )}
        <h1 className={classes.tituloPrincipal}>{props.title}</h1>
      </Grid>

      {props.showDivider && (
        <Divider  className={classes.divider}/>
      )}
    </Fragment>
  );
}

TituloConImagen.defaultProps = {
  showIcon: true,
  showButton: false,
  titleButton: "",
  showDivider: false,
}

export default TituloConImagen;
